import { render } from "./PaymentResultView.vue?vue&type=template&id=4bcd78fa&scoped=true"
import script from "./PaymentResultView.vue?vue&type=script&lang=js"
export * from "./PaymentResultView.vue?vue&type=script&lang=js"

import "./PaymentResultView.vue?vue&type=style&index=0&id=4bcd78fa&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bcd78fa"]])

export default __exports__